//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * @class am.TraductionSelectorController
     */
    module.TraductionSelectorController = function() {
        // Private attributes
        this._view = undefined; // reference to the view associated with the controller
        this._map  = undefined; // reference to the map
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Object specifying the configuration to be applied to the controller. 
     */
    module.TraductionSelectorController.prototype.init = function(mainController, config) {
        var _this = this;
        this._map = mainController.getMapObject();

          // Merge the config specified by the user with the default config
          this._config = am.utils.mergeObjects(this._config, config);
  
          // Instantiate the private attributes, except for the autocomplete object and its associated event listener object
          this._view = am.utils.traductionSelectorView(this._config).addTo(this._map);

    };
    
    return module;

})(am || {});

//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.TraductionSelectorController
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Configuration object to be passed to the constructor of class 
     *      am.TraductionSelectorController
     * @return {am.TraductionSelectorController} - New instance of class am.TraductionSelectorController
     */
    module.traductionSelectorController = function(mainController, config) {
        var ctrl = new am.TraductionSelectorController();
        ctrl.init(mainController, config);
        return ctrl;
    };

    return module;

})(am.utils || {});